import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import AppDialog from "@/components/common/AppDialog";

const SurveyDeleteQuestionDialog = ({ open, onOpenChange, onConfirm }) => {
  const { t } = useTran();

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("Delete Question")}
      description={t("This will permanently delete the selected question.")}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange?.(false)}>
            {t("Cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t("Delete")}
          </Button>
        </div>
      }
    />
  );
};

export default SurveyDeleteQuestionDialog;
